<form [formGroup]="form | bgoAsFormGroup" *transloco="let t">
  <div class="space-y-md">
    <label class="mt-xs font-bold">{{ t('createJobRequest.catDoorInstallationForm.target.label') }}</label>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.target | bgoAsFormControl"
      [value]="InstallationTarget.Window"
    >
      {{ t('createJobRequest.catDoorInstallationForm.target.window') }}
    </cft-radio>
    <cft-radio [formControl]="form.controls.target | bgoAsFormControl" [value]="InstallationTarget.Door">
      {{ t('createJobRequest.catDoorInstallationForm.target.door') }}
    </cft-radio>
    <cft-radio [formControl]="form.controls.target | bgoAsFormControl" [value]="InstallationTarget.Other">
      {{ t('createJobRequest.catDoorInstallationForm.target.other') }}
    </cft-radio>
    @if (form.controls.target.touched && form.controls.target.invalid) {
      <span class="error">
        {{ t('createJobRequest.catDoorInstallationForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.target.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.catDoorInstallationForm.surface.label') }}</label>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.surface | bgoAsFormControl"
      [value]="InstallationSurface.Glass"
    >
      {{ t('createJobRequest.catDoorInstallationForm.surface.glass') }}
    </cft-radio>
    <cft-radio [formControl]="form.controls.surface | bgoAsFormControl" [value]="InstallationSurface.Wood">
      {{ t('createJobRequest.catDoorInstallationForm.surface.wood') }}
    </cft-radio>
    @if (form.controls.target.value === InstallationTarget.Other) {
      <cft-radio [formControl]="form.controls.surface | bgoAsFormControl" [value]="InstallationSurface.Stone">
        {{ t('createJobRequest.catDoorInstallationForm.surface.stone') }}
      </cft-radio>
    }
    <cft-radio [formControl]="form.controls.surface | bgoAsFormControl" [value]="InstallationSurface.Other">
      {{ t('createJobRequest.catDoorInstallationForm.surface.other') }}
    </cft-radio>
    @if (form.controls.surface.touched && form.controls.surface.invalid) {
      <span class="error">
        {{ t('createJobRequest.catDoorInstallationForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.surface.invalid">
    <label class="mt-xs font-bold">
      {{ t('createJobRequest.catDoorInstallationForm.measurement.label') }}
    </label>
    <div class="w-2/3 md:w-1/2 lg:w-1/3 xl:w-1/4">
      <cft-form-field>
        <label>{{ t('createJobRequest.catDoorInstallationForm.measurement.width') }}</label>
        <input type="number" [formControl]="form.controls.width | bgoAsFormControl" />
        <span class="error">
          {{ t('createJobRequest.catDoorInstallationForm.errors.width', {size: minimumCatDoorWindowSizeInCm}) }}
        </span>
      </cft-form-field>
      <cft-form-field>
        <label>{{ t('createJobRequest.catDoorInstallationForm.measurement.height') }}</label>
        <input type="number" [formControl]="form.controls.height | bgoAsFormControl" />
        <span class="error">
          {{ t('createJobRequest.catDoorInstallationForm.errors.height', {size: minimumCatDoorWindowSizeInCm}) }}
        </span>
      </cft-form-field>
    </div>
  </div>
  <div
    class="gradual-reveal mt-2xl space-y-md"
    [class.gradual-reveal-hidden]="
      form.controls.width.invalid ||
      form.controls.height.invalid ||
      form.controls.surface.value !== InstallationSurface.Glass
    "
  >
    <label class="mt-xs font-bold">{{ t('createJobRequest.catDoorInstallationForm.strength.label') }}</label>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.glassStrength | bgoAsFormControl"
      [value]="GlassStrength.Single"
    >
      {{ t('createJobRequest.catDoorInstallationForm.strength.single') }}
    </cft-radio>
    <cft-radio [formControl]="form.controls.glassStrength | bgoAsFormControl" [value]="GlassStrength.Double">
      {{ t('createJobRequest.catDoorInstallationForm.strength.double') }}
    </cft-radio>
    <cft-radio [formControl]="form.controls.glassStrength | bgoAsFormControl" [value]="GlassStrength.Triple">
      {{ t('createJobRequest.catDoorInstallationForm.strength.triple') }}
    </cft-radio>
    @if (form.controls.glassStrength.touched && form.controls.glassStrength.invalid) {
      <span class="error">
        {{ t('createJobRequest.catDoorInstallationForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  @if ({invalid: form.controls.glassStrength.invalid}; as glassStrength) {
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="
        glassStrength.invalid || form.controls.width.invalid || form.controls.height.invalid
      "
    >
      <label class="mt-xs font-bold">{{ t('createJobRequest.catDoorInstallationForm.frame.label') }}</label>
      <cft-radio class="mt-xs block" [formControl]="form.controls.frame | bgoAsFormControl" [value]="Frame.WoodWood">
        {{ t('createJobRequest.catDoorInstallationForm.frame.wood') }}
      </cft-radio>
      <cft-radio [formControl]="form.controls.frame | bgoAsFormControl" [value]="Frame.WoodMetal">
        {{ t('createJobRequest.catDoorInstallationForm.frame.woodMetal') }}
      </cft-radio>
      <cft-radio [formControl]="form.controls.frame | bgoAsFormControl" [value]="Frame.PlasticPlastic">
        {{ t('createJobRequest.catDoorInstallationForm.frame.plastic') }}
      </cft-radio>
      <cft-radio [formControl]="form.controls.frame | bgoAsFormControl" [value]="Frame.Other">
        {{ t('createJobRequest.catDoorInstallationForm.frame.other') }}
      </cft-radio>
      @if (form.controls.frame.touched && form.controls.frame.invalid) {
        <span class="error">
          {{ t('createJobRequest.catDoorInstallationForm.errors.atLeastOneOptionSelected') }}
        </span>
      }
    </div>
  }
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.frame.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.catDoorInstallationForm.assemblyHeight.label') }}</label>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.assemblyHeight | bgoAsFormControl"
      [value]="AssemblyHeight.Under_1M"
    >
      {{ t('createJobRequest.catDoorInstallationForm.assemblyHeight.underOneMeter') }}
    </cft-radio>
    <cft-radio [formControl]="form.controls.assemblyHeight | bgoAsFormControl" [value]="AssemblyHeight.Above_1M">
      {{ t('createJobRequest.catDoorInstallationForm.assemblyHeight.aboveOneMeter') }}
    </cft-radio>
    @if (form.controls.assemblyHeight.touched && form.controls.assemblyHeight.invalid) {
      <span class="error">
        {{ t('createJobRequest.catDoorInstallationForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.assemblyHeight.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.catDoorInstallationForm.catDoor.label') }}</label>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.catDoor | bgoAsFormControl"
      [value]="'USE_OWN'"
      [hasWarning]="form.controls.catDoor.value === 'USE_OWN'"
    >
      {{ t('createJobRequest.catDoorInstallationForm.catDoor.own') }}
    </cft-radio>
    @if (form.controls.catDoor.value === 'USE_OWN') {
      <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"> </span>
    }
    <cft-radio [formControl]="form.controls.catDoor | bgoAsFormControl" [value]="'STANDARD'">
      {{ t('createJobRequest.catDoorInstallationForm.catDoor.standard') }}
    </cft-radio>
    <cft-radio [formControl]="form.controls.catDoor | bgoAsFormControl" [value]="'CHIP'">
      {{ t('createJobRequest.catDoorInstallationForm.catDoor.chip') }}
    </cft-radio>
    @if (form.controls.catDoor.touched && form.controls.catDoor.invalid) {
      <span class="error">
        {{ t('createJobRequest.catDoorInstallationForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
</form>
